<townip-modal heading="Bulk Price Freeze" size="lg" (onHide)="cleanup()">
	<townip-modal-body>
		<p>
			Please select which client (and end client,
			if applicable) for which you would like to bulk price freeze renewal services.
		</p>

		<form class="w-50" #bulkFreezeForm="ngForm">
			<div class="form-group">
				<label>Client</label>
				<townip-dropdown
					class="standard-control"
					placeholder="Please Select"
					name="selectedCompany"
					[(ngModel)]="selectedCompany"
					(ngModelChange)="setupEndClient()"
					required>
					<townip-option
						*ngFor="let client of companies"
						[label]="client.companyName"
						[value]="client.id">
					</townip-option>
				</townip-dropdown>
			</div>
			<div class="form-group">
				<label>End Client (Optional)</label>
				<townip-dropdown
					[disabled]="!endClients?.length"
					class="standard-control"
					placeholder="Please Select"
					name="selectedEndClient"
					[(ngModel)]="selectedEndClient">
          <townip-option label="None" [value]="null"></townip-option>
					<townip-option
						*ngFor="let endClient of endClients"
						[label]="endClient.companyName"
						[value]="endClient.id">
					</townip-option>
				</townip-dropdown>
			</div>
		</form>

	</townip-modal-body>
	<townip-modal-footer>
		<button class="btn btn-secondary" (click)="hide()">Cancel</button>
		<button class="btn btn-primary" (click)="confirm(bulkFreezeForm)">Confirm</button>
	</townip-modal-footer>
</townip-modal>
